import {
    isMobile,
    isMobileOnly,
    isTablet,
    osName,
    osVersion,
} from 'mobile-device-detect';
import Game from '../../Game';
import { Random } from '../Random';
import {
    eventQueue,
    getDataSetByKey,
    initializeTrackingDataHandlers,
    track,
} from './Track';
import { restoreNumber } from '../../Player/ParseHelper';

let DDNA_URL: string;

export enum Platform {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    FACEBOOK = 'FACEBOOK',
    UNKNOWN = 'UNKNOWN',
}

export function enableTracking() {
    // DDNA_URL = Game.config.DDNA_URL + Game.config.DDNA_KEY + '/bulk';
    initializeTrackingDataHandlers();

    track('sessionID', Random.ID());
    // track('gameID', Game.config.gameID);
    track('gameVersion', Game.config.version);
    track('deviceType', getDeviceType());
    track('operatingSystemVersion', osVersion);
    track('operatingSystem', getOS());
    track('platform', Platform.IOS);
    track('frameRate', Game.config.fpsLimit);
    track('screenHeight', window.innerHeight);
    track('screenWidth', window.innerWidth);

    loadPersistentTrackingData();

    //flushEvents();
}

interface ITrackingData {
    [sessionNum: string]: number;
    lastLevelAttempted: number;
    lastLevelWon: number;
}

let savedTrackingData: ITrackingData = {
    sessionNum: 0,
    lastLevelAttempted: 0,
    lastLevelWon: 0,
};

export async function loadPersistentTrackingData() {
    if (!window.hasOwnProperty('localStorage')) return;
    try {
        const data = Object.keys(window.localStorage).reduce(
            (acc: any, key: string) => {
                const val = window.localStorage.getItem(key);

                if (val) {
                    const numeric = restoreNumber(val);
                    if (!isNaN(numeric) && typeof numeric === 'number') {
                        acc[key] = numeric;
                    } else if (val === 'null') {
                        acc[key] = null;
                    } else {
                        acc[key] = val;
                    }
                }
                return acc;
            },
            {}
        );
        if (hasPersistentTrackingData(data)) {
            track('sessionNum', data.sessionNum + 1);
            track('lastLevelAttempted', data.lastLevelAttempted);
            track('lastLevelWon', data.lastLevelWon);
        } else {
            track('sessionNum', 1);
            track('lastLevelAttempted', 0);
            track('lastLevelWon', 0);
        }
    } catch (e) {
        console.log('Error on restoring tracking data: ', e);
    }
}

export function savePersistentTrackingData() {
    if (!window.hasOwnProperty('localStorage')) return;
    const metaData = getDataSetByKey('sessionNum');
    const trackingData: ITrackingData = {
        sessionNum: metaData['sessionNum'],
        lastLevelWon: metaData['lastLevelWon'],
        lastLevelAttempted: metaData['lastLevelAttempted'],
    };
    if (compareTrackingData(trackingData, savedTrackingData)) {
        savedTrackingData = { ...trackingData };
        try {
            Object.keys(trackingData).forEach(key => {
                window.localStorage.setItem(key, trackingData[key].toString());
            });
        } catch (e) {
            console.log('Error on Saving Tracking Data: ', e);
        }
    }
}

/**
 * check if the player already has save data
 * @param data
 */
function hasPersistentTrackingData(data: any): boolean {
    return !!data && !!data.sessionNum;
}

/**
 * Checks if trackingData changed and the game needs to save it
 * Reduces amount of network calls
 * @param trackingData
 * @param savedData
 */
function compareTrackingData(
    trackingData: ITrackingData,
    savedData: ITrackingData
): boolean {
    return (
        trackingData.sessionNum &&
        trackingData.sessionNum !== 0 &&
        (trackingData.sessionNum !== savedData.sessionNum ||
            trackingData.lastLevelAttempted !== savedData.lastLevelAttempted ||
            trackingData.lastLevelWon !== savedData.lastLevelWon)
    );
}

function flushEvents() {
    if (!Game.config.trackingEnabled) return;
    savePersistentTrackingData();
    if (eventQueue.length > 0) {
        const list = [...eventQueue];
        eventQueue.length = 0;

        const postData = JSON.stringify({ eventList: list });
        const request = new XMLHttpRequest();
        // request.open('POST', DDNA_URL, true);

        // tslint:disable-next-line:no-console
        console.log('DDNA Events :: ', list);

        try {
            request.send(postData);
        } catch (err) {
            console.log('DDNA Event Flush Error :: ', err);
            eventQueue.push(...list);
        }
    }

    // setTimeout(flushEvents, Game.config.DDNA_EventSendInterval);
}

const supportedOSStrings = [
    'WINDOWS',
    'OSX',
    'LINUX',
    'IOS',
    'TVOS',
    'ANDROID',
    'FIREOS',
    'BLACKBERRY',
    'UNKNOWN',
];

function getOS(): string {
    const name = osName.toUpperCase();
    if (name === 'UBUNTU') return 'LINUX';
    if (name === 'MAC OS') return 'OSX';

    if (supportedOSStrings.includes(name)) return name as any;
    return 'UNKNOWN';
}

function getDeviceType(): string {
    if (isMobileOnly) return 'MOBILE_PHONE';
    if (isTablet) return 'TABLET';
    if (!isMobile) return 'PC';
    return 'UNKNOWN';
}
